'use strict';

class AccountIntegrations {
  constructor(originatorService, I18N, Notification) {
    this.originatorService = originatorService;
    this.I18N = I18N;
    this.Notification = Notification;
  }

  update(agency = 'LINDORFF') {
    this.settings.defaults.collectionAgency = agency;

    this.originatorService.updateSettings(this.settings)
      .then(() => {
        this.Notification.success(this.I18N.general.saved);
      });
  }
}

AccountIntegrations.$inject = ['originatorService', 'I18N', 'Notification'];

const accountIntegrations = {
  bindings: {
    originator: '<',
    settings: '<'
  },
  controller: AccountIntegrations,
  template: `
    <h2>Tilleggstjenester</h2>

    <account-tabs active-tab="integrations"></account-tabs>

    <ocr></ocr>

    <h3 class="subheader">Inkasso</h3>
    <lindorff-agency></lindorff-agency>
    <bewa-agency></bewa-agency>

    <efaktura></efaktura>
    <dropbox></dropbox>
  `
};

angular
  .module('SendRegning')
  .component('accountIntegrations', accountIntegrations)
  .config(($routeProvider) => {
    $routeProvider
      .when('/konto/integrasjoner', {
        title: 'Tilleggstjenester',
        template: '<account-integrations originator="$resolve.originator" settings="$resolve.settings" />',
        resolve: {
          originator: (originatorService) => originatorService.get().then((resp) => resp.data),
          settings: (originatorService) => originatorService.settings().then((resp) => resp.data)
        },
        secure: true
      });
  });
